import React from 'react';
import useFirebase from '../../Hooks/useFirebase';
import './AboutMe.css'

const AboutMe = () => {
    const { user } = useFirebase();
    return (
        <div className='container my-3'>
            <h3>Welcome! <span className='text-primary'>{user ? user?.displayName : 'You'}</span> for your curious to know About Me</h3>

            <div className='d-flex flex-column justify-content-center align-items-center mt-2'>
           
               <img className='img-set' src="https://i.ibb.co/xjKcqpv/circle-img.png" alt="Dhananjoy" />
                <h3 className='mb-3 border-bottom p-2'>Name: <span className='text-danger'>Dhananjoy Chandra Das</span></h3>
                <p className='text-center'> <h6>My goal and what I think about my goal to make success. Let's Start</h6>At preset, I set my goal to make me a full stack web developer and after that I will do job or got enough money and opportunity, I will establish a Technology institution where many people make them busy by doing job. Now, I have to Work hard and make me a self confident person to achieve my goal. I will keep on my learning process. </p>
     
            </div>

        </div>
    );
};

export default AboutMe;